import { CellComponent } from './CellComponent';

export default CellComponent;
